import { render, staticRenderFns } from "./ScannerBenchmark.vue?vue&type=template&id=a8c65b14&scoped=true&"
import script from "./ScannerBenchmark.vue?vue&type=script&lang=js&"
export * from "./ScannerBenchmark.vue?vue&type=script&lang=js&"
import style0 from "./ScannerBenchmark.vue?vue&type=style&index=0&id=a8c65b14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c65b14",
  null
  
)

export default component.exports